import { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function setMetaDescription(content) {
  if (typeof document === 'undefined') return;
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function Contacto() {
  useEffect(() => {
    document.title = 'Contacto | Huelmu';
    setMetaDescription(
      'Contáctanos en Huelmu. Escríbenos a contacto@huelmu.cl para más información sobre nuestros productos y proyectos ambientales.'
    );
    // Hacer scroll al inicio cuando se carga la página
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #fafaf8 0%, #f5f5f0 100%)',
        position: 'relative',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <Navbar />
      <Container 
        maxWidth="sm" 
        sx={{ 
          position: 'relative', 
          zIndex: 1,
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            pt: { xs: 12, sm: 14, md: 16 },
            pb: { xs: 6, sm: 8 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
              fontWeight: 700,
              lineHeight: { xs: 1.25, sm: 1.2 },
              mb: { xs: 3, sm: 4 },
              color: 'text.primary',
            }}
          >
            Contacto
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: '1rem', sm: '1.1rem' },
              mb: { xs: 2, sm: 2.5 },
              color: 'text.secondary',
              maxWidth: '500px',
              lineHeight: 1.6,
            }}
          >
            Escríbenos y te responderemos a la brevedad.
          </Typography>

          <Box
            component="a"
            href="mailto:contacto@huelmu.cl"
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.4rem' },
              fontWeight: 500,
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 0.7,
                textDecoration: 'underline',
              },
            }}
          >
            contacto@huelmu.cl
          </Box>
        </Box>
      </Container>

      <Footer />
    </Box>
  );
}

export default Contacto;

